"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentStatus = void 0;
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["CREATED"] = "CREATED";
    DocumentStatus["VALIDATION_ASKED"] = "VALIDATION_ASKED";
    DocumentStatus["VALIDATED"] = "VALIDATED";
    DocumentStatus["REFUSED"] = "REFUSED";
    DocumentStatus["OUT_OF_DATE"] = "OUT_OF_DATE";
})(DocumentStatus || (exports.DocumentStatus = DocumentStatus = {}));
//# sourceMappingURL=DocumentStatus.js.map